<template>
  <div class="alert-page">
    <div class="emoji">{{ emoji }}</div>
    <div class="title">{{ title }}</div>
    <div class="content">
      <slot name="content"/>
    </div>
    <div class="button" v-if="showButton">
      <riseup-button :action="buttonAction" :title="buttonTitle" :size="'small'" :disabled="buttonDisabled" :variant="buttonVariant"/>
    </div>
    <support-footer v-if="showSupportFooter" />
  </div>
</template>

<script>
import BaseUI from 'base-ui';

export default {
  name: 'AlertPage',
  components: {
    RiseupButton: BaseUI.RiseupButton,
    SupportFooter: BaseUI.SupportFooter,
  },
  props: {
    emoji: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    showButton: {
      type: Boolean,
      default: false,
    },
    buttonAction: Function,
    buttonTitle: String,
    buttonVariant: {
      type: String,
      default: 'primary',
    },
    buttonDisabled: {
      type: Boolean,
      default: false,
    },
    showSupportFooter: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
  @import '../scss/mixins';

  .alert-page {
    margin: 40px 30px 30px;
    text-align: center;
  }

  .emoji {
    font-size: 76px;
    margin-bottom: 30px;
  }

  .title {
    @include title();
    font-weight: bold;
    margin-bottom: 12px;
  }

  .content {
    line-height: 24px;
    margin-bottom: 24px;

    .bold {
      font-weight: bold;
    }
  }

  .button {
    margin-top: 40px;
  }

</style>



// WEBPACK FOOTER //
// src/base-components/AlertPage.vue